import type { EventLandingConfig } from "@/components/EventLandingPage";
import { SITE } from "@/lib/site";

export const MARVEL_EVENT = {
  path: "/marvel",
  title: "Jay Chou Night, Sat 17 Oct | Angkor Cambodian Flavours",
  description:
    "Jay Chou Night at Marvel, Sat 17 Oct. Cambodian feasts at Angkor, about 11 minutes' walk from the stadium. Angkor Feast $79 pp, Royal Khmer Feast $99 pp.",
  kicker: "JAY CHOU NIGHT · Saturday 17 October",
  date: "Saturday 17 October",
  headline: "Jay Chou Night at Marvel. Feast first.",
  line: "Heading to Marvel Stadium on Saturday 17 October? Start with a Cambodian feast at Angkor, about 11 minutes' walk from the stadium.",
  offerLine: "Angkor Feast $79 pp · Royal Khmer Feast $99 pp · prices include GST.",
  bookingNote: "Book early and mention MARVEL. We'll have you fed and out the door in time for the show. Seating times to be confirmed.",
  offers: [
    {
      name: "Angkor Feast",
      price: "$79 per person",
      intro: "Shared banquet for the table.",
      menu: [
        {
          group: "To start",
          dishes: "Betel Leaf, Beef Skewer, Papaya Salad",
        },
        {
          group: "Salad",
          dishes: "Mango Salad with char-grill Barramundi",
        },
        {
          group: "Mains to share",
          dishes: "Amok (fish or chicken), Beef Loc Lac",
        },
        { group: "With", dishes: "Jasmine Rice, Coconut Brown Rice" },
        {
          group: "Dessert",
          dishes: "Sticky Rice Egg Custard + Coconut Ice Cream duo",
        },
      ],
    },
    {
      name: "Royal Khmer Feast",
      price: "$99 per person",
      intro: "A fuller premium table, banquet-style.",
      menu: [
        {
          group: "To start",
          dishes: "Fish Cake, Spring Roll, BBQ Scallop",
        },
        {
          group: "Salads",
          dishes: "Banana Blossom Salad with chicken, Papaya Salad",
        },
        {
          group: "Mains to share",
          dishes: "Fish Amok, Beef Loc Lac with Kampot pepper, Samlor Machu Kroeung Sach Ko",
        },
        { group: "With", dishes: "Jasmine Rice, Asian Roti" },
        {
          group: "Desserts",
          dishes: "Black Rice Pudding + Sticky Rice Mango duo",
        },
      ],
    },
  ],
  menuNote:
    "Sample menus — dishes may vary seasonally. Vegetarian, vegan and gluten-free alternatives available — tell us when you book.",
  details: [
    "Minimum 2 guests per feast.",
    "Drinks on consumption.",
    "Mention MARVEL when you book.",
    "Book now, and we'll confirm your prepayment by phone.",
    "Prices include GST.",
  ],
  bookingLabel: "Book your table",
  bookingUrl:
    "https://reserve.oddle.me/en_AU/angkorcafe?utm_source=website&utm_medium=marvel&utm_campaign=jaychou",
  utmCampaign: "jaychou",
  phoneHref: `tel:${SITE.phone}`,
  phoneDisplay: SITE.phoneDisplay,
  address: "389 Spencer St, West Melbourne.",
  hero: {
    src: SITE.images.fishAmok,
    srcSet: `${SITE.images.fishAmok480} 480w, ${SITE.images.fishAmok640} 640w, ${SITE.images.fishAmok960} 960w, ${SITE.images.fishAmok} 1200w`,
    alt: "Fish Amok at ANGKOR Cambodian Flavours",
  },
} as const satisfies EventLandingConfig;
